import { Image, Text, View } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { IMyTableProps } from '../../shared/component/Table';
import variable from '../../shared/style/variable';
import Error from '../image/Error.png';
import Flag from '../image/Flag.png';
import styles from '../style';

interface ITableProps extends IMyTableProps {}

export default (props: ITableProps) => {
    const { t } = useTranslation();
    return (
        <View style={styles.tableContainer}>
            <View style={styles.tableHeader}>
                <View style={styles.tableRow}>
                    {props.data.columns.map((x, u) => (
                        <View style={{ ...styles.tableCell, paddingLeft: 10 }}>
                            <Text>{x}</Text>
                        </View>
                    ))}
                </View>
            </View>
            {props.data.rows.map((x, u) => (
                <View
                    style={{
                        ...styles.tableRow,
                        ...(x.isBold ? styles.bold : null),
                        backgroundColor: u % 2 === 0 ? variable.turquoise_100 : variable.white,
                    }}>
                    <View style={{ ...styles.tableCell, paddingLeft: 10 }}>
                        <Text>{x.label}</Text>
                    </View>
                    {x.values.map(x => {
                        let error = typeof x.value == 'boolean' ? x.value : typeof x.check == 'boolean' ? x.check : undefined;
                        return (
                            <View style={styles.tableCell}>
                                <View
                                    style={{
                                        ...styles.tableRow,
                                        border: error == undefined ? '' : x.check || error ? `1px solid ${variable.turquoise_500}` : `1px solid ${variable.red_800}`,
                                        backgroundColor: error == undefined ? '' : error ? variable.green_100 : variable.red_100,
                                    }}>
                                    <View style={{ ...styles.tableCell, paddingLeft: 10 }}>
                                        {x.value == undefined ? (
                                            <Text>-</Text>
                                        ) : typeof x.value == 'boolean' ? (
                                            x.value ? (
                                                <Image src={Flag} style={{ height: 10, width: 10 }} />
                                            ) : (
                                                <Image src={Error} style={{ height: 10, width: 10 }} />
                                            )
                                        ) : (
                                            <Text>{x.value}</Text>
                                        )}
                                    </View>
                                    {x.check !== undefined && typeof x.value !== 'boolean' && (
                                        <View style={{ ...styles.tableCell, borderLeft: `1px solid ${variable.turquoise_600}` }}>
                                            <View style={styles.tableRow}>
                                                <View style={{ ...styles.tableCell, paddingLeft: 10 }}>
                                                    <Text style={{ color: variable.turquoise_600 }}>{t('check')}</Text>
                                                </View>
                                                <View style={{ ...styles.tableCell, paddingLeft: 10 }}>
                                                    {x.check ? (
                                                        <Image src={Flag} style={{ height: 10, width: 10, margin: 'auto' }} />
                                                    ) : (
                                                        <Image src={Error} style={{ height: 10, width: 10, margin: 'auto' }} />
                                                    )}
                                                </View>
                                            </View>
                                        </View>
                                    )}
                                </View>
                            </View>
                        );
                    })}
                </View>
            ))}
        </View>
    );
};
